import { Table, TableProps, Tag } from 'antd';
import { TextField } from '@refinedev/antd';
import type { IHtmlContainer } from 'interfaces/prometheus';

interface HtmlContainersTableProps {
  tableProps: TableProps<IHtmlContainer>;
}

const translateState = (state: string) => {
  switch (state) {
    case 'pending': {
      return 'Pendente';
    }

    case 'processing': {
      return 'Processando';
    }

    case 'processed': {
      return 'Concluído';
    }

    default: {
      return 'Desconhecido';
    }
  }
};

export const HtmlContainersTable = ({
  tableProps
}: HtmlContainersTableProps) => {
  return (
    <Table {...tableProps} rowKey="id">
      <Table.Column
        dataIndex="name"
        key="name"
        title="Nome"
        render={value => <TextField value={value} />}
      />

      <Table.Column
        dataIndex="state"
        key="state"
        title="Status"
        render={value => <Tag>{translateState(value)}</Tag>}
      />
    </Table>
  );
};
